module.exports = __webpack_public_path__ + "img/bg-magento-find-out@2x.06ea8dc4.webp";